import { useEffect } from "react";

/**
 * StructuredData Component - Adds JSON-LD structured data for SEO
 * 
 * Usage:
 * <StructuredData 
 *   type="WebApplication"
 *   data={{...}}
 * />
 */
const StructuredData = ({ type, data }) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = `structured-data-${type.toLowerCase()}`;
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": type,
      ...data,
    });

    // Remove existing script if it exists
    const existing = document.getElementById(script.id);
    if (existing) {
      existing.remove();
    }

    document.head.appendChild(script);

    return () => {
      // Cleanup on unmount
      const scriptToRemove = document.getElementById(script.id);
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [type, data]);

  return null;
};

export default StructuredData;

